export const appBuildAssetsDir = "/_nuxt/"

export const appKeepalive = false

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"name":"applicable-device","content":"pc,mobile"},{"name":"format-detection","content":"telephone=yes"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"http-equiv":"content-language","content":"en"},{"http-equiv":"Cache-Control","content":"no-transform"},{"name":"keywords","content":"Taro-trip,tarotrip,taroTrip,TAROTRIP,TARO-TRIP,taro-trip,online travel,travel agent,online booking,airline ticket, plane ticket, hotel nights,flights,rooms,holiday,trip,vacation,indonesia,singapore,malaysia,australia,china,hong kong,asia,europe,hotel,cheap flight,cheap tickets,cheap rates,domestic flight,international flight,promo rate,lionair,garuda,batavia,Merpati,Sriwijaya,singapore airline"},{"name":"description","content":"Taro-trip.com Online Travel - Cheap Hotels & Flights bookings - domestic & international. 200,000 hotels worldwide. compare 500 airlines- 24/7 fast booking !"}],"link":[{"rel":"stylesheet","href":"/static/css/animate.min.css","type":"text/css"},{"rel":"stylesheet","href":"/static/css/swiper.css","type":"text/css"},{"rel":"stylesheet","href":"/static/css/fonts/iconfont/iconfont.css","type":"text/css"}],"style":[],"script":[{"type":"text/javascript","src":"/static/js/wow.js","defer":true},{"type":"text/javascript","src":"https://www.googletagmanager.com/gtag/js?id=GTM-N4HHV9B8","async":true},{"type":"text/javascript","src":"https://www.googletagmanager.com/gtm.js?id=GTM-N4HHV9B8","async":true},{"type":"text/javascript","src":"/static/js/googleTag.js"},{"type":"text/javascript","src":"/static/js/skyscannerDvTag.js"},{"type":"text/javascript","src":"/static/js/laydate/laydate.js"},{"type":"text/javascript","src":"/static/js/swiper.min.js"},{"type":"text/javascript","defer":true,"src":"/static/js/wowInit.js"}],"noscript":[],"charset":"utf-8","title":"Taro-trip"}

export const appRootId = "app"

export const appRootTag = "div"

export const appLayoutTransition = false

export const appBaseURL = "/"

export const appCdnURL = ""

export const appPageTransition = false

export const appViewTransition = false

export const appRootAttrs = {"id":"app"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#app'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000